import { render, staticRenderFns } from "./ProductSearchField.vue?vue&type=template&id=3b1d849d"
import script from "./ProductSearchField.vue?vue&type=script&lang=ts"
export * from "./ProductSearchField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports